import { defineMessages } from 'react-intl';

const translationMessages = defineMessages({
  booking: {
    id: 'hosting.payouts_utils.booking_text',
    defaultMessage: 'booking'
  },
  ancillary: {
    id: 'hosting.payouts_utils.add_ons_text',
    defaultMessage: 'Add-ons'
  },
  overtime: {
    id: 'hosting.payouts_utils.overtime_text',
    defaultMessage: 'Overtime'
  },
  damages: {
    id: 'hosting.payouts_utils.damages_text',
    defaultMessage: 'Damages'
  },
  referralCommission: {
    id: 'hosting.payouts_utils.referral_commision_text',
    defaultMessage: 'Host referral'
  },
  paid: {
    id: 'hosting.payouts_utils.paid_text',
    defaultMessage: 'Paid'
  },
  processing: {
    id: 'hosting.payouts_utils.processing_text',
    defaultMessage: 'Processing'
  },
  onHold: {
    id: 'hosting.payouts_utils.on_hold_text',
    defaultMessage: 'On Hold'
  },
  scheduled: {
    id: 'hosting.payouts_utils.scheduled_text',
    defaultMessage: 'Scheduled'
  },
  failed: {
    id: 'hosting.payouts_utils.failed_text',
    defaultMessage: 'Retrying'
  },
  addonsAlt: {
    id: 'hosting.payouts_utils.addons_alt',
    defaultMessage: 'addons'
  },
  referralAlt: {
    id: 'hosting.payouts_utils.referral_alt',
    defaultMessage: 'referral'
  }
});

export const itemCategory = {
  booking: {
    text: translationMessages.booking,
    icon: 'booking',
    alt: translationMessages.booking
  },
  ancillary: {
    text: translationMessages.ancillary,
    icon: 'addons',
    alt: translationMessages.addonsAlt
  },
  overtime: {
    text: translationMessages.overtime,
    icon: 'overtime',
    alt: translationMessages.overtime
  },
  DAMAGES: {
    text: translationMessages.damages,
    icon: 'damages',
    alt: translationMessages.damages
  },
  referral_commission: {
    text: translationMessages.referralCommission,
    icon: 'referral',
    alt: translationMessages.referralAlt
  }
};


export const payoutStatus = {
  paid: {
    text: translationMessages.paid,
    class: 'success'
  },
  processing: {
    text: translationMessages.processing,
    class: 'warning'
  },
  on_hold: {
    text: translationMessages.onHold,
    class: 'warning'
  },
  scheduled: {
    text: translationMessages.scheduled,
    class: 'warning'
  },
  failed: {
    text: translationMessages.failed,
    class: 'danger'
  }
};
